import { useEffect } from "react";
import Lenis from "lenis";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { EditorialMarquee } from "@/components/EditorialMarquee";
import { MusicSection } from "@/components/MusicSection";
import { StoriesSection } from "@/components/StoriesSection";
import { Manifesto } from "@/components/Manifesto";
import { ContactSection } from "@/components/ContactSection";
import { Footer } from "@/components/Footer";
import { AudioBar } from "@/components/AudioBar";

export default function Home() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.2, smoothWheel: true });
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <main className="bg-sand-50 text-sand-900 overflow-x-clip">
      <Navbar />
      <Hero />
      <EditorialMarquee />
      <MusicSection />
      <StoriesSection />
      <Manifesto />
      <ContactSection />
      <Footer />
      <AudioBar />
    </main>
  );
}
